import { useEffect } from 'react';
import { getScopeElements, isInside } from './utils';
export const useDisableClickOutside = (props) => {
    const { scope, enabled = true, onClickOutside } = props;
    useEffect(() => {
        function handleClick(event) {
            var _a, _b;
            if (!enabled)
                return;
            const target = (_b = (_a = event.composedPath) === null || _a === void 0 ? void 0 : _a.call(event)[0]) !== null && _b !== void 0 ? _b : event.target;
            const elements = getScopeElements(scope);
            // Suppress if inside current scope
            if (isInside(elements, target))
                return; // How to prevent disabling on popovers?
            event.stopPropagation();
            event.preventDefault();
            if (onClickOutside)
                onClickOutside(event);
        }
        document === null || document === void 0 ? void 0 : document.addEventListener('mousedown', handleClick);
        document === null || document === void 0 ? void 0 : document.addEventListener('touchstart', handleClick);
        return () => {
            document === null || document === void 0 ? void 0 : document.removeEventListener('mousedown', handleClick);
            document === null || document === void 0 ? void 0 : document.removeEventListener('touchstart', handleClick);
        };
    }, [enabled, scope, onClickOutside]);
};
//# sourceMappingURL=useDisableClickOutside.js.map